import React, { Component } from 'react'
import EstateCard from './EstateCard'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { graphql, Link, useStaticQuery } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export default function Estates(props: {full: boolean}) {

    const data = useStaticQuery(graphql`
    query {
        allContentfulHyresratt {
            edges {
                node {
                    town
                    image { file { url } }
                    node_locale
        		    about {about}
                }
            }
        }
    }
    `)

    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (<>
        <section className="estates-mobile">
            <div className="estates-mobile__heading p-margin">
                <h1 className="fs-mont-sh">Våra fastigheter</h1>
                {/*
                {!props.full ? (<Link to="/fastigheter"><button className="btn-round">Se fler</button></Link>) : ""}                
                */}
            </div>
            <Slider {...settings}>
                    {data.allContentfulHyresratt.edges.filter(e => e.node.node_locale === "sv-SE").map(edge => (
                        <div>
                            <EstateCard src={edge.node.image.file.url} name={edge.node.town} about={edge.node.about.about} />
                        </div>
                    ))}
            </Slider>
        </section>
        <section className="estates">
            <div className="estates__content p-margin">

                <div className="estates__content__heading split-50">
                    <div className="estates__content__heading__title">
                        <h1 className="fs-mont-sh">Våra fastigheter</h1>
                    </div>
                    <div className="estates__content__heading__seemore">
                        {/*
                        {!props.full ? (<Link to="/fastigheter"><button className="btn-round">Se fler</button></Link>) : ""}
                        
                        */}
                    </div>
                </div>

                <div className="estates__content__grid">
                    {data.allContentfulHyresratt.edges.filter(e => e.node.node_locale === "sv-SE").map(edge => (
                        <EstateCard src={edge.node.image.file.url} name={edge.node.town} about={edge.node.about.about} />
                    ))}
                </div>

            </div>
        </section>
    </>
    )
}